const useStyles = {
  outerContainer: {
    marginBottom: 2,
  },
  emptyStateContainer: {
    justifyContent: 'center',
    marginTop: 2,
  },
  needHelpWrapper: {
    marginTop: 3,
  },
}

export default useStyles
